/* eslint-disable no-underscore-dangle */
import { loadJS } from 'hobbit-base/modules/utils';

const ENV_ENUM = {
  dev: 'local',
  test: 'daily',
  pre: 'pre',
  gray: 'gray',
  prod: 'prod',
}
export default function arms({ $ctx, $user, $config }) {
  window.__bl = {
    config: {
      pid: 'epn9tbrnui@9044a004c6caa9d',
      appType: 'web',
      imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
      sendResource: true,
      enableLinkTrace: true,
      behavior: true,
      enableSPA: true,
      useFmp: true,
      release: `${$config.log.appName}-${$ctx.version}`,
      environment: ENV_ENUM[$ctx.runtime] || 'local',
    },
  };
  loadJS('https://sdk.rum.aliyuncs.com/v1/bl.js', 1e4, false)
    .then(() => {
      // 若有用户id，设置uid
      const userId = $user.vkUserId();
      if (userId) {
        window.__bl.setConfig({
          uid: `${$ctx.biz}-${userId}`,
        });
      }
    })
    .catch(error => {
      console.warn('Load arms\'s SDK Failed', error);
    });
}
